import React, { useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../../../../app/actions/generalActions";
import { SpecificationEditDialogHeader } from "./SpecificationEditDialogHeader";
import { SpecificationEditForm } from "./SpecificationEditForm";
import { useSpecificationsUIContext } from "../SpecificationsUIContext";
import { useFilterObjectsUIContext } from "../../pages/FilterObjectsUIContext";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export function SpecificationEditDialog({ showTitle, reduxName, api, formFields, prepareFilter, editFormFields, ObjectEditSchema, isFullAccess = false }) {
  // Specifications UI Context
  const specsUIContext = useSpecificationsUIContext();
  const filterUIContext = useFilterObjectsUIContext();

  const specsUIProps = useMemo(() => {
    return {
      id: specsUIContext.selectedId,
      show: specsUIContext.showEditSpecificationDialog,
      onHide: specsUIContext.closeEditSpecificationDialog,
      parentId: specsUIContext.parentId,
      parentName: specsUIContext.parentName,
      queryParams: filterUIContext.queryParams,
      initSpecification: specsUIContext.initSpecification,
    };
  }, [specsUIContext, filterUIContext]);

  // Specifications Redux state
  const dispatch = useDispatch();
  const { actionsLoading, specificationForEdit, name } = useSelector(
    (state) => ({
      actionsLoading: state[reduxName].actionsLoading,
      specificationForEdit: state[reduxName].objectForEdit,
      name: state[reduxName].name,
    }),
    shallowEqual
  );

  useEffect(() => {
    // server request for getting spec by seleted id
    dispatch(actions.fetchObject(api, name, specsUIProps.id));
  }, [specsUIProps.id, dispatch]);

  const saveSpecification = (specification) => {
    if (!specsUIProps.id) {
      dispatch(actions.createObject(api, name, specification)).then(() => {
        dispatch(
          actions.fetchObjectsByParentId(
            api,
            name,
            specsUIProps.queryParams,
            specsUIProps.parentId,
            specsUIProps.parentName,
          )
        ).then(() => {
          specsUIProps.onHide();

        });
      });
    } else {
      dispatch(actions.updateObject(api, name, specification)).then(() => {
        dispatch(
          actions.fetchObjectsByParentId(
            api,
            name,
            specsUIProps.queryParams,
            specsUIProps.parentId,
            specsUIProps.parentName,
          )
        ).then(() => {
          specsUIProps.onHide();

        });
      });
    }
  };

  return (
    <Modal

      show={specsUIProps.show}
      onHide={specsUIProps.onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      <SpecificationEditDialogHeader showTitle={showTitle} id={specsUIProps.id} reduxName={reduxName} />
      <SpecificationEditForm
        saveSpecification={saveSpecification}
        actionsLoading={actionsLoading}
        specification={specificationForEdit || specsUIProps.initSpecification}
        onHide={specsUIProps.onHide}
        formFields={specsUIProps.id ? editFormFields : formFields}
        prepareFilter={prepareFilter}
        isFullAccess={isFullAccess}
      />
    </Modal>
  );
}
// export function SpecificationEditDialog({ reduxName="auditListFormResults", api="api/AuditListFormResult" }) {
//   // Specifications UI Context
//   const specsUIContext = useSpecificationsUIContext();
//   const filterUIContext = useFilterObjectsUIContext();

//   const specsUIProps = useMemo(() => {
//     return {
//       id: specsUIContext.selectedId,
//       show: specsUIContext.showEditSpecificationDialog,
//       onHide: specsUIContext.closeEditSpecificationDialog,
//       parentId: specsUIContext.parentId,
//       queryParams: filterUIContext.queryParams,
//       initSpecification: specsUIContext.initSpecification,
//     };
//   }, [specsUIContext, filterUIContext]);

//   // Specifications Redux state
//   const dispatch = useDispatch();
//   const { actionsLoading, name,lastError,lastMsg } = useSelector(
//     (state) => ({
//       actionsLoading: state[reduxName].actionsLoading,
//       // specificationForEdit: state[reduxName].specificationForEdit,
//     }),
//     shallowEqual
//   );

//   // useEffect(() => {
//   //   // server request for getting spec by seleted id
//   //   dispatch(actions.fetchObject(api,name,specsUIProps.id));
//   // }, [specsUIProps.id, dispatch]);

//   const saveSpecification = (specification) => {
//     if (!specsUIProps.id) {
//       dispatch(actions.createObject(api, name, specification)).then(() => {
//         dispatch(
//           actions.fetchObjects(api, name,
//             specsUIProps.queryParams
//             // ,specsUIProps.parentId
//           )
//         ).then(() => {
//           specsUIProps.onHide();
//           if (lastError) {
//             toast.error(lastError, {
//               position: "bottom-left",
//               autoClose: 5000
//             })
//           }
//           if(lastMsg){
//             toast.success(lastMsg, {
//               position: "bottom-left",
//               autoClose: 5000
//             })
//           }
//         });
//       });
//     } else {
//       dispatch(actions.updateObject(api, name, specification)).then(() => {
//         dispatch(
//           actions.fetchObjects(api, name,
//             specsUIProps.queryParams
//             // ,specsUIProps.parentId
//           )
//         ).then(() => {
//           specsUIProps.onHide();
//           if (lastError) {
//             toast.error(lastError, {
//               position: "bottom-left",
//               autoClose: 5000
//             })
//           }
//           if(lastMsg){
//             toast.success(lastMsg, {
//               position: "bottom-left",
//               autoClose: 5000
//             })
//           }
//         });
//       });
//     }
//   };

//   return (
//     <Modal
//       show={specsUIProps.show}
//       onHide={specsUIProps.onHide}
//       aria-labelledby="example-modal-sizes-title-lg"
//     >
//       <SpecificationEditDialogHeader id={specsUIProps.id} />
//       {/* <SpecificationEditForm
//         saveSpecification={saveSpecification}
//         actionsLoading={actionsLoading}
//         specification={specificationForEdit || specsUIProps.initSpecification}
//         onHide={specsUIProps.onHide}
//       /> */}
//     </Modal>
//   );
// }
